import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, Modal } from "antd";
import { actions as commonActions } from "../../store/commonRedux/actions";
import { MobileOutlined } from "@ant-design/icons";
import { useMediaQuery } from "../../hooks";
import StoreOptions from "../DownloadAppButton/StoreOptions";
import { isInsideApp } from "../DownloadAppButton/env";
import styles from "./styles.module.css";

const HINT_KEY = "install-prompt";

const isTourOpen = () => Boolean(document.querySelector(".ant-tour"));

const InstallAppPrompt = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const dispatch = useDispatch();

  const isDismissed = useSelector(
    ({ common }) => !!common.dismissedHints?.[HINT_KEY],
  );

  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (!isMobile || isInsideApp() || isDismissed) return;

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (!isTourOpen()) {
        setOpen(true);
        clearInterval(timer);
      } else if (attempts >= 10) {
        clearInterval(timer);
      }
    }, 2000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const close = () => {
    if (dontShowAgain) dispatch(commonActions.dismissHint(HINT_KEY));
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      centered
      width={520}
      title={
        <span>
          <MobileOutlined className="ms-2" />
          تجربه بهتر با اپلیکیشن تسکامون
        </span>
      }
      footer={
        <div className={styles.footer}>
          <Checkbox
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          >
            متوجه شدم، دیگر این پیام را نشان نده
          </Checkbox>
          <Button type="primary" onClick={close}>
            بستن
          </Button>
        </div>
      }
    >
      <p className={styles.intro}>
        به نظر می‌رسد با موبایل وارد شده‌اید. برای سرعت بیشتر، اعلان‌های لحظه‌ای
        و دسترسی راحت‌تر، اپلیکیشن تسکامون را نصب کنید.
      </p>
      <StoreOptions />
    </Modal>
  );
};

export default InstallAppPrompt;
